module.exports = __webpack_public_path__ + "img/download.de4eeff9.svg";